import RpcService from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type Shipment from '@/domains/Shipments/Shipment';
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";
import type DeliveryType from "@/domains/DeliveryTypes/DeliveryType";
import type Partner from "@/domains/Partners/Partner";
import type Company from "@/domains/Companies/Company";
import type Person from "@/domains/Persons/Person";
import type Product from "@/domains/Product/Product";
import type ProductCategory from "@/domains/ProductCategories/ProductCategory";
import type DateRange from "@/core/types/DateRange";

/**
 * DAO для работы с отгрузками
 */
class ShipmentsDAO {

	static async get(id: number, isAdminMode?: boolean): Promise<RpcResponse> {
		return await RpcService.makeRequest('shipments.get', {
			id,
			isAdminMode,
		});
	}

	static async getList(
		filters?: {
			idPattern?:               number;
			isOfferBased?:            boolean;
			isSamples?:               boolean;
			orderCategory?:           object;
			deliveryType?:            DeliveryType;
			seller?:                  Partner;
			sellerCompany?:           Company;
			buyer?:                   Partner;
			buyerCompany?:            Company;
			responsible?:             Person;
			product?:                 Product;
			productCategory?:         ProductCategory;
			codePattern?:             string;
			isShipped?:               boolean;
			isShippedEntirely?:       boolean;
			isTransportOrderCreated?: boolean;
			isReceived?:              boolean;
			desiredReceiptPeriod?:    DateRange;
			plannedShipmentPeriod?:   DateRange;
			assemblyPeriod?:          DateRange;
			isAdminMode?:             boolean;
			isForTestsOnly?:          boolean;
		},
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'shipments.getList',
      {
        ...filters,
        deliveryType:    filters?.deliveryType ? { id: filters.deliveryType.id } : undefined,
        seller:          filters?.seller ? { id: filters.seller.id } : undefined,
        sellerCompany:   filters?.sellerCompany ? { id: filters.sellerCompany.id } : undefined,
        buyer:           filters?.buyer ? { id: filters.buyer.id } : undefined,
        buyerCompany:    filters?.buyerCompany ? { id: filters.buyerCompany.id } : undefined,
        responsible:     filters?.responsible ? { id: filters.responsible.id } : undefined,
        product:         filters?.product ? { id: filters.product.id } : undefined,
        productCategory: filters?.productCategory ? { id: filters.productCategory.id } : undefined,
      },
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	static async add(shipment: Shipment): Promise<RpcResponse> {
		return await RpcService.makeRequest('shipments.add', { shipment });
	}

	static async update(shipment: Shipment, changeReasonText?: string): Promise<RpcResponse> {
		return await RpcService.makeRequest('shipments.update', {
			shipment,
			changeReasonText,
		});
	}

	static async delete(id: number, changeReasonText?: string): Promise<RpcResponse> {
		return await RpcService.makeRequest('shipments.delete', {
			shipment: { id },
			changeReasonText,
		});
	}
}

export default ShipmentsDAO;
